//import VueJwtDecode from 'vue-jwt-decode';
import router from '@/router';
import {axios} from "@/api";

const state = {
  isAuth: false,
  authorities: null,
  profile: {},
};

// getters
/* eslint-disable no-shadow */
const getters = {
  isAuth(state) {
    return state.isAuth;
  },
  profile(state) {
    return state.profile;
  },
  isAdmin(state) {
    return state.authorities?.find((it) => it === 'ROLE_ADMIN') !== undefined
  }
};

// actions
const actions = {

  init({commit}) {
    commit('setIsAuth', localStorage.getItem('access_token') != null);
  },

  login({commit}, model) {
    const data = {
      email: model.username.toLowerCase().trim(),
      password: model.password.trim(),
    };
    return axios.post(`${process.env.VUE_APP_AUTH}/api/v1/user/auth`, data, {headers: {'Accept-Language': 'ru'}}).then((result) => commit('setTokenData', result.data.item));
  },

  fetchProfile({commit}) {
    return axios.get(`${process.env.VUE_APP_API_SOC}/user/profile`)
      .then((result) => commit('setProfile', result.data));
  },

  logout({commit}, backUrl) {
    commit('setTokenData', null);

    if (backUrl && backUrl !== router.currentRoute.path) {
      router.replace(backUrl || '/login');
    }
  },

  recoveryCode({commit}, model) {
    return axios.get(`${process.env.VUE_APP_API}/api/v1/user/sendLostcode?email=${model.email.trim()}`, {headers: {'Accept-Language': 'ru'}}).then(() => commit('setRecoveryCodeData'));
  },

  sendRecoveryCode({commit}, model) {
    const data = {
      code: model.code.trim(),
    };
    return axios.put(`${process.env.VUE_APP_AUTH}/api/v2/user/lostpass`, data, {headers: {'Accept-Language': 'ru'}}).then(() => commit('setRecovery'));
  },

};

// mutations
/* eslint-disable no-shadow */
const mutations = {
  setTokenData(state, data) {
    if (data != null) {
      localStorage.access_token = data.access_token;
      localStorage.refresh_token = data.refresh_token;
      localStorage.access_expires = data.access_expires;
      localStorage.refresh_expires = data.refresh_expires;
      //const tokenData = data.access_token;
      //state.authorities = tokenData.authorities
      state.isAuth = true;
    } else {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('access_expires');
      localStorage.removeItem('refresh_expires');
      localStorage.removeItem('isOpenMenu');
      state.isAuth = false;
    }
  },
  setProfile(state, data) {
    if (data != null) {
      localStorage.payment_expired = data.paymentExpired;
    } else {
      localStorage.payment_expired = false;
    }
    state.profile = data;
  },
  setIsAuth(state, value) {
    state.isAuth = value;
  },
  setRecoveryCodeData(state) {
    state.isAuth = false;
  },
  setRecovery(state) {
    state.isAuth = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
